import './animations.css';

export const FROM_BELOW = 'from-below';
export const OUT_ABOVE = 'out-above';
export const FADE_OUT = 'fade-out-v2';
export const FADE_IN = 'fade-in';
export const FROM_ABOVE = 'from-above';
export const OUT_BELOW = 'out-below';
export const SHRINK_MARGIN_TOP = 'shrink-margin-top';
export const EXIT_OUT_LEFT = 'exit-out-left';
export const DONE_INDICATOR = 'done-indicator';
export const HOLD = 'hold';
export const PULSATE_AFTER = 'pulsate-after';

export function triggerAnimation(el: HTMLElement | null, name: string, onEnd?: () => void) {
	if (!el) {
		return;
	}
	const cssClass = `animation--${name}`;
	// TODO: If an animations isn't triggered, the deregister never happens, and may instead be triggered later
	el.addEventListener('animationend', deregister, {once: true});
	el.classList.add(cssClass);

	function deregister() {
		// El may have been removed before the animation ends
		if (el) {
			el.classList.remove(cssClass);
		}

		if (onEnd) {
			onEnd();
		}
	}
}

export function exitWithTransition(el: HTMLElement, className: string) {
	el.classList.add(className);
	el.addEventListener(
		'transitionend',
		() => {
			el.remove();
			el.classList.remove(className);
		},
		{once: true}
	);
}

export function exitWithNextEl(el: HTMLElement, nextEl: HTMLElement | undefined, name: string) {
	const cssClass = `animation--${name}`;
	el.addEventListener('animationend', remove, {once: true});
	const preExitHeight = el.clientHeight;
	const preMarginTop = el.style.marginTop;
	el.classList.add(cssClass);
	if (nextEl) {
		nextEl.style.setProperty('--margin-top-start', `${preExitHeight}px`);
		nextEl.style.setProperty('--margin-top-end', preMarginTop);
		triggerAnimation(nextEl, 'shrink-margin-top');
	}

	function remove() {
		el.remove();
	}
}
